<nz-layout class="app-layout">
  <nz-content>
    <div class="inner-content" nz-row>
      <div nz-col nzSpan="12" nzOffset="6" [nzXs]="{span: 24, offset: 0}" [nzSm]="{span: 24}"
           [nzMd]="{span: 20, offset: 2}" [nzLg]="{span: 16, offset: 4}" [nzXl]="{span: 12, offset: 6}">
        <h1 class="main-title">Carvry Admin</h1>
        <div class="auth-form">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </nz-content>
</nz-layout>
